import {useStyles} from './styles'

const Separator = () => {
  const classes = useStyles();
  return <hr className={classes.separator} />;
};

export default Separator